import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  IRoute,
  TokenService
} from 'viggo-sistemas-core-web';

import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { CombustivelService } from '@app/modules/combustivel/services/combustivel.service';
import { ModeloTransporteService } from '@app/modules/modelo_transporte/services/modelo_transporte.service';
import { IMotorista } from '@app/modules/motorista/models/motorista.model';
import { MotoristaService } from '@app/modules/motorista/services/motorista.service';
import { IVeiculo } from '@app/modules/veiculo/model/veiculo.model';
import { VeiculoService } from '@app/modules/veiculo/services/veiculo.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { ScreenService } from '@app/shared/services';
import {
  validarAdicaoRaiz,
  verificarRotasDeAcessoRaiz
} from '@app/shared/utils';
import { Dialog } from 'primeng/dialog';

@Component({
  templateUrl: './fast-veiculo.component.html',
  styleUrls: ['./fast-veiculo.component.scss'],
  providers: [
    MotoristaService,
    ModeloTransporteService,
    CombustivelService,
    VeiculoService
  ]
})
export class FastVeiculoComponent implements OnInit, AfterViewInit {
  @ViewChild('fastVeiculo') fastVeiculo: Dialog;
  public form: UntypedFormGroup;

  loading = false;

  displayMessage = {
    placa: {
      required: 'A placa é obrigatória',
      maxlength: 'Deve conter até 7 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!',
      duplicate: 'Já existe essa placa registrada no sistema'
    },
    estado: {
      required: 'O estado é obrigatório',
      maxlength: 'Deve conter até 2 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    descricao: {
      required: 'A descrição é obrigatória',
      maxlength: 'Não pode ter mais de 120 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    chassi: {
      required: 'O chassi é obrigatório',
      maxlength: 'Deve conter até 17 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!',
      duplicate: 'Já existe esse chassi registrado no sistema'
    },
    tipo_veiculo: {
      maxlength: 'Deve conter até 25 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    tipo_rodado: {
      maxlength: 'Deve conter até 25 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    cor: {
      maxlength: 'Deve conter até 20 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    tara: {
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      max_value: 'Inválido: passou dos limites',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    },
    capacidade_kg: {
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      max_value: 'Inválido: passou dos limites',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    },
    capacidade_m3: {
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      max_value: 'Inválido: passou dos limites',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    },
    antt: {
      maxlength: 'Deve conter até 20 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    renavam: {
      maxlength: 'Deve conter até 11 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    ano_modelo: {
      minlength: 'Valor inválido',
      maxlength: 'Valor inválido',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      max_value: 'Inválido: passou dos limites',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    },
    ano_fabricacao: {
      minlength: 'Valor inválido',
      maxlength: 'Valor inválido',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      max_value: 'Inválido: passou dos limites',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    }
  };

  focusElement: any;
  inputElementDtVencExt: boolean;
  ID_FIELD_DTVENCEXT = 'field-vencimento-extintor';
  ID_DTPICKER_VENCEXT = 'dtPickerToggleDtVencExt';

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastVeiculoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IVeiculo,
    protected fb: UntypedFormBuilder,
    protected entityService: VeiculoService,
    protected combustivelService: CombustivelService,
    protected motoristaService: MotoristaService,
    protected modeloTransporteService: ModeloTransporteService,
    public tokenService: TokenService,
    public matDialog: MatDialog,
    public router: Router,
    protected matSnackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      placa: [
        null,
        [
          Validators.required,
          Validators.maxLength(7),
          CustomValidators.isEmptyValue(),
          CustomValidators.existSpecialChar()
        ]
      ],
      estado: [
        null,
        [
          Validators.required,
          Validators.maxLength(2),
          CustomValidators.isEmptyValue()
        ]
      ],
      descricao: [
        null,
        [
          Validators.required,
          Validators.maxLength(120),
          CustomValidators.isEmptyValue()
        ]
      ],
      chassi: [
        null,
        [
          Validators.required,
          Validators.maxLength(17),
          CustomValidators.isEmptyValue(),
          CustomValidators.existSpecialChar()
        ]
      ],
      tipo_veiculo: [
        null,
        [Validators.maxLength(25), CustomValidators.isEmptyValue()]
      ],
      tipo_rodado: [
        null,
        [Validators.maxLength(25), CustomValidators.isEmptyValue()]
      ],
      cor: [null, [Validators.maxLength(20), CustomValidators.isEmptyValue()]],
      tara: [
        null,
        [
          CustomValidators.existSpecialChar(true),
          CustomValidators.validateCurrencyValues(13, 3)
        ]
      ],
      capacidade_kg: [
        null,
        [
          CustomValidators.existSpecialChar(true),
          CustomValidators.validateCurrencyValues(13, 3)
        ]
      ],
      capacidade_m3: [
        null,
        [
          CustomValidators.existSpecialChar(true),
          CustomValidators.validateCurrencyValues(13, 3)
        ]
      ],
      antt: [null, [Validators.maxLength(20), CustomValidators.isEmptyValue()]],
      renavam: [
        null,
        [Validators.maxLength(11), CustomValidators.isEmptyValue()]
      ],
      ano_modelo: [
        null,
        [
          Validators.minLength(4),
          Validators.maxLength(4),
          CustomValidators.existSpecialChar()
        ]
      ],
      ano_fabricacao: [
        null,
        [
          Validators.maxLength(4),
          Validators.minLength(4),
          CustomValidators.existSpecialChar()
        ]
      ],
      vencimento_extintor: [null],
      combustivel: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      modelo_veiculo: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      motorista: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.validateForm();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      const { ...rest } = this.form.value;
      let entity = {
        domain_id: this.tokenService.getDomain().id,
        ...rest,
        motorista_id: this.form.value.motorista.id,
        combustivel_id: this.form.value.combustivel.id,
        modelo_veiculo_id: this.form.value.modelo_veiculo.id,
        tara: this.form.value.tara
          ? Utils.replaceCommaToDot(this.form.value.tara)
          : null,
        capacidade_kg: this.form.value.capacidade_kg
          ? Utils.replaceCommaToDot(this.form.value.capacidade_kg)
          : null,
        capacidade_m3: this.form.value.capacidade_m3
          ? Utils.replaceCommaToDot(this.form.value.capacidade_m3)
          : null,
        ano_fabricacao: this.form.value.ano_fabricacao
          ? Number(this.form.value.ano_fabricacao)
          : null,
        ano_modelo: this.form.value.ano_modelo
          ? Number(this.form.value.ano_modelo)
          : null
      };
      entity = Utils.onlyAttributes(
        Utils.clearObject(Utils.trimAttributes(entity)),
        [
          'motorista_id',
          'combustivel_id',
          'modelo_veiculo_id',
          'placa',
          'chassi',
          'id',
          'domain_id',
          'descricao',
          'estado',
          'tipo_veiculo',
          'tipo_rodado',
          'cor',
          'tara',
          'capacidade_kg',
          'capacidade_m3',
          'antt',
          'renavam',
          'ano_modelo',
          'ano_fabricacao',
          'vencimento_extintor'
        ]
      );
      this.entityService.insert(entity).subscribe(
        servico => {
          if (servico) {
            this.matSnackBar.open(`Novo veículo cadastrado com sucesso.`, 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(servico);
          }
        },
        (err: HttpErrorResponse) => {
          this.displayError(err);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    }
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  validateNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  /**
   * Verifica se preenche ou nao o menu de user
   * @returns
   */
  checkDisponibilidade(action: string, params = '', url: string) {
    const routesAuthorization = verificarRotasDeAcessoRaiz(
      this.tokenService.getRoutes(),
      url
    ) as IRoute[];

    const url_return = validarAdicaoRaiz(
      routesAuthorization,
      action,
      params,
      url
    );
    // eslint-disable-next-line no-unneeded-ternary
    return url_return ? true : false;
  }

  public checkChassiOuPlaca(checarChassi: boolean): void {
    const { chassi } = this.form.controls;
    const { placa } = this.form.controls;

    if (checarChassi) {
      if (chassi.invalid) return;
      const chassiValue: string = chassi.value;
      this.entityService
        .getEntitiesByParams(
          `chassi=${chassiValue}`,
          this.tokenService.getDomain().id
        )
        .subscribe(
          veiculo => {
            if (veiculo.length) {
              chassi.setErrors({ duplicate: true });
              this.form.updateValueAndValidity();
            }
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    } else {
      if (placa.invalid) return;
      const placaValue: string = placa.value;
      this.entityService
        .getEntitiesByParams(
          `placa=${placaValue}`,
          this.tokenService.getDomain().id
        )
        .subscribe(
          veiculo => {
            if (veiculo.length) {
              placa.setErrors({ duplicate: true });
              this.form.updateValueAndValidity();
            }
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    }
  }

  displayFn = (parceiro: IMotorista): string => {
    if (!parceiro) return '';
    return parceiro.parceiro.nome_razao_social;
  };

  onFocus(event, input?: boolean) {
    if (input !== undefined && input !== null)
      if (document.activeElement.id === this.ID_FIELD_DTVENCEXT) {
        this.inputElementDtVencExt =
          event?.target?.id === document.activeElement.id;
      } else {
        this.inputElementDtVencExt = false;
      }
    if (event) {
      this.focusElement = event.target?.id;
    } else {
      this.focusElement = null;
    }
  }

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastVeiculo.maximize();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
